import { Component } from '@angular/core';

@Component({
  selector: 'app-inventory-serial-movement',
  standalone: false,
  
  templateUrl: './inventory-serial-movement.component.html',
  styles: ``
})
export class InventorySerialMovementComponent {

}
